import React, { useEffect, useState } from "react";
import { datosWorker, updateWorker } from "../functions/WorkersQueries";
import { permisos_administracion, permisos_cartera, permisos_comerciales, EXCEPCIONES_PERMISOS } from "../functions/constants";

const Permisos = ({
  verPermisos,
  setVerPermisos,
  setRefrescar,
  setNuevoTrabajador,
  id_usuario,
}) => {
  const [data, setData] = useState({
    permiso_3: 0, // Reportes
    permiso_15: 0, // Listado de trabajadores
    permiso_16: 0, // Análisis de cobranza
    permiso_17: 0, // Reporte de colocación
    permiso_20: 0, // Altas
    permiso_21: 0, // Bajas
    permiso_30: 0, // Estados de cuenta
    permiso_33: 0, // Gestión de créditos activos
    permiso_34: 0, // Administración de créditos activos
    permiso_35: 0, // Proyecciones
    nombre: '',
    clave_organizacion: '',
    id_usuario: '',
  });

  // Obtener permisos exceptuados para la organización actual
  const permisosExceptuados = React.useMemo(() => {
    if (!data.clave_organizacion) return [];
    const excepcion = EXCEPCIONES_PERMISOS.find(ex => ex.clave_organizacion === String(data.clave_organizacion));
    return excepcion ? excepcion.permisos_no_permitidos : [];
  }, [data.clave_organizacion]);

  const submitForm = (e) => {
    e.preventDefault();
    // Unificar permisos seleccionados de todos los bloques
    const allPermisos = [
      ...permisos_comerciales,
      ...permisos_cartera,
      ...permisos_administracion,
    ];
    const uniquePermisos = Array.from(new Set(allPermisos.map(p => p.key)));
    const bloques = ["comerciales", "cartera", "administracion"];
    const permisosSeleccionados = {};
    uniquePermisos.forEach(key => {
      const checked = bloques.some(bloque => {
        const checkbox = document.getElementById(`${key}_${bloque}`);
        return checkbox && checkbox.checked;
      });
      permisosSeleccionados[key] = checked ? 1 : 0;
    });
    // Crear objeto final solo con los campos originales y permisos
    let dataFinal = {
      ...data,
      ...permisosSeleccionados,
    };
    // Eliminar todas las propiedades que terminan en _comerciales, _cartera o _administracion
    Object.keys(dataFinal).forEach(key => {
      if (/_comerciales$|_cartera$|_administracion$/.test(key)) {
        delete dataFinal[key];
      }
    });
    // Aplicar excepciones: desactivar permisos no permitidos
    permisosExceptuados.forEach(permiso => {
      dataFinal[permiso] = 0;
    });
    updateWorker(dataFinal);
    // mandar alerta de que se actualizo correctamente
    alert("Permisos actualizados correctamente");
    setNuevoTrabajador(0);
    regresar();
  };

  const updateField = (e) => {
    const key = e.target.name.replace(/_(comerciales|cartera|administracion)$/, "");
    // Si el permiso está exceptuado, no permitir cambiarlo
    if (permisosExceptuados.includes(key)) return;
    setData({ ...data, [key]: e.target.checked ? 1 : 0 });
  };

  const seleccionarPermisos = (permisos, bloque) => {
    // Solo seleccionar los que no están exceptuados
    const nuevosDatos = { ...data };
    permisos.forEach((permiso) => {
      if (!permisosExceptuados.includes(permiso.key)) {
        nuevosDatos[permiso.key] = 1;
        const checkbox = document.getElementById(`${permiso.key}_${bloque}`);
        if (checkbox && !checkbox.checked) {
          checkbox.checked = true;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        // Si está exceptuado, asegúrate de que esté desmarcado
        nuevosDatos[permiso.key] = 0;
        const checkbox = document.getElementById(`${permiso.key}_${bloque}`);
        if (checkbox && checkbox.checked) {
          checkbox.checked = false;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
    setData(nuevosDatos);
  };

  const regresar = () => {
    setTimeout(() => {
      setRefrescar(1);
    }, 1000);
  };

  useEffect(() => {
    datosWorker(verPermisos, (userArr) => {
      if (!userArr) return;
      const user = userArr;
      const allPermisos = [
        ...permisos_comerciales,
        ...permisos_cartera,
        ...permisos_administracion,
      ];
      const uniquePermisos = Array.from(new Set(allPermisos.map(p => p.key)));
      // Combina los datos previos con los nuevos para no perder campos
      const newData = { ...data, ...user };
      console.log('NEW DATA', newData);
      uniquePermisos.forEach(key => {
        newData[key] = user.permisos && user.permisos.includes(key) ? 1 : 0;
      });
      // Desactivar permisos exceptuados
      const excepcion = EXCEPCIONES_PERMISOS.find(ex => ex.clave_organizacion === String(user.clave_organizacion));
      if (excepcion) {
        excepcion.permisos_no_permitidos.forEach(permiso => {
          newData[permiso] = 0;
        });
      }
      setData(newData);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verPermisos]);

  console.log('DATA', data);

  return (
    <>
      <div className="mt-6 text-xl font-semibold text-center text-sky-700">
        Permisos {data && `del usuario ${data.nombre} ${verPermisos}`}
      </div>

      <div className="mt-4 text-center text-sky-700">
        <button
          className="px-3 py-1 mx-4 text-white bg-gray-500 rounded-xl hover:bg-slate-400 hover:text-black hover:duration-500"
          onClick={() => seleccionarPermisos(permisos_comerciales, "comerciales")}
        >
          Seleccionar todos los permisos comerciales
        </button>
      </div>
      {permisos_comerciales.map((permiso, idx) => (
        <div
          className={`flex flex-row items-center max-w-full my-2 ${idx % 2 === 0 ? "bg-slate-300" : ""}`}
          key={permiso.key + "_comerciales"}
        >
          <div className="w-1/2 text-center mx-9">
            <span>{permiso.label}</span>
          </div>
          <div className="w-1/2 p-1 mr-3">
            <input
              type="checkbox"
              name={`${permiso.key}_comerciales`}
              id={`${permiso.key}_comerciales`}
              className="w-5 h-5 form-checkbox text-sky-600"
              checked={!!data[permiso.key]}
              onChange={updateField}
              disabled={permisosExceptuados.includes(permiso.key)}
            />
          </div>
        </div>
      ))}

      <div className="mt-4 text-center text-sky-700">
        <button
          className="px-3 py-1 mx-4 text-white bg-gray-500 rounded-xl hover:bg-slate-400 hover:text-black hover:duration-500"
          onClick={() => seleccionarPermisos(permisos_cartera, "cartera")}
        >
          Seleccionar todos los permisos de cartera
        </button>
      </div>
      {permisos_cartera.map((permiso, idx) => (
        <div
          className={`flex flex-row items-center max-w-full my-2 ${idx % 2 === 0 ? "bg-slate-300" : ""}`}
          key={permiso.key + "_cartera"}
        >
          <div className="w-1/2 text-center mx-9">
            <span>{permiso.label}</span>
          </div>
          <div className="w-1/2 p-1 mr-3">
            <input
              type="checkbox"
              name={`${permiso.key}_cartera`}
              id={`${permiso.key}_cartera`}
              className="w-5 h-5 form-checkbox text-sky-600"
              checked={!!data[permiso.key]} 
              onChange={updateField}
              disabled={permisosExceptuados.includes(permiso.key)}
            />
          </div>
        </div>
      ))}

      <div className="mt-4 text-center text-sky-700">
        <button
          className="px-3 py-1 mx-4 text-white bg-gray-500 rounded-xl hover:bg-slate-400 hover:text-black hover:duration-500"
          onClick={() => seleccionarPermisos(permisos_administracion, "administracion")}
        >
          Seleccionar todos los permisos de administración
        </button>
      </div>
      {permisos_administracion.map((permiso, idx) => (
        <div
          className={`flex flex-row items-center max-w-full my-2 ${idx % 2 === 0 ? "bg-slate-300" : ""}`}
          key={permiso.key + "_administracion"}
        >
          <div className="w-1/2 text-center mx-9">
            <span>{permiso.label}</span>
          </div>
          <div className="w-1/2 p-1 mr-3">
            <input
              type="checkbox"
              name={`${permiso.key}_administracion`}
              id={`${permiso.key}_administracion`}
              className="w-5 h-5 form-checkbox text-sky-600"
              checked={!!data[permiso.key]}
              onChange={updateField}
              disabled={permisosExceptuados.includes(permiso.key)}
            />
          </div>
        </div>
      ))}

      <form method="POST" onSubmit={submitForm}>
        <div className="flex flex-row items-center justify-center mt-4 mb-16">
          <button
            className="px-3 py-1 mx-4 text-white bg-gray-500 rounded-xl hover:bg-slate-400 hover:text-black hover:duration-500"
            onClick={() => setVerPermisos()}
          >
            Cancelar
          </button>
          <button
            className="px-3 py-1 mx-4 text-white bg-gray-500 rounded-xl hover:bg-slate-400 hover:text-black hover:duration-500"
            type="submit"
          >
            Actualizar
          </button>
        </div>
      </form>
    </>
  );
};

export default Permisos;
